export default __webpack_public_path__ + "locales/pt/Webhooks.json?hash=7e6e016438afd2dac148703799c7095c";